"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APSelect = _interopRequireDefault(require("../common/APSelect"));
var _config = _interopRequireDefault(require("../../config"));
var _wsHelper = require("../../helpers/wsHelper");
var _wsConnectionActions = require("../../redux/actions/wsConnectionActions");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./TradingServerComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('trading-server');
var TradingServer = function TradingServer() {
  var _useTranslation = (0, _reactI18next.useTranslation)('auth'),
    t = _useTranslation.t;
  var currentServer = (0, _wsHelper.getGateway)(_config["default"].global.gateway);
  var tradingServers = _config["default"].global.gateway.filter(function (item) {
    return item !== currentServer;
  }).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "gateway",
    label: "".concat(t('Select server'), ":"),
    showTriangles: true,
    customClass: baseClasses(),
    onSelect: function onSelect(value) {
      return (0, _wsConnectionActions.changeServer)(value);
    },
    options: [{
      value: currentServer,
      label: currentServer
    }, {
      value: 'CUSTOM',
      label: t('Custom server...')
    }].concat(_toConsumableArray(tradingServers))
  });
};
var _default = exports["default"] = TradingServer;